import { type ClassValue,clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Conditional classes via `clsx`, conflict resolution via `tailwind-merge`.
 *
 * String concatenation is banned in its place because it leaves both conflicting utilities in the
 * class list and the winner is then decided by stylesheet order, not by the caller. `cn('px-4',
 * 'px-2')` resolves to `px-2`; `` `px-4 ${'px-2'}` `` resolves to whichever Tailwind emitted last.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
